module.exports = __webpack_public_path__ + "static/media/icon-timepay.0c8ffdae.png";